// extracted by mini-css-extract-plugin
export default {"grid":"fRcosF","weekDays":"yAbykF","weekDay":"IQl9f3","loading":"kFgwW1","week":"iNt7p6","days":"nxkL5B"};